export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";